import { useEffect } from 'react';

import { useSearchActions } from 'modules/search/contexts/SearchContext';

import type { SearchContextInput } from './useSearchContextHeaderInput';

type Args = {
  searchContextInput: SearchContextInput | undefined;
  isSearching: boolean | undefined;
};

export function useSearchContextHeaderFetchPage({
  searchContextInput,
  isSearching,
}: Args) {
  const { fetchSearchPageResults } = useSearchActions();

  useEffect(() => {
    if (!searchContextInput || isSearching) return;

    const { currentResultIndex, pageIndex, resultsByPage } = searchContextInput;
    const results = resultsByPage[pageIndex];

    // pre-fetch the previous page of results if we're on one of the first two results in the page
    if (
      currentResultIndex <= 1 &&
      pageIndex > 0 &&
      !resultsByPage[pageIndex - 1]
    ) {
      fetchSearchPageResults(pageIndex - 1);
    }

    // pre-fetch the next page of results if we're on one of the last two results in the page
    if (
      currentResultIndex >= (results?.hitsPerPage || 0) - 2 &&
      pageIndex < (results?.nbPages || 0) - 1 &&
      !resultsByPage[pageIndex + 1]
    ) {
      fetchSearchPageResults(pageIndex + 1);
    }
  }, [fetchSearchPageResults, isSearching, searchContextInput]);
}
